<template>
  <div class="booking-instructions">
    <content-section
      title="Accedi alla tua prenotazione sul sito della compagnia aerea"
    >
      <p>
        Accedi sul sito della compagnia utilizzando il codice
        <b>{{ carrier_reference }}</b> ed il nominativo
        <b>{{ contact_name_surname }}</b>
        <br />
        <small>
          (nel caso in cui venisse richiesto anche un indirizzo email,
          utilizza <strong>{{ email_pnr }}</strong>)
        </small>
      </p>
      <hr />
      <div class="h3 ml-0 mb-1">I tuoi bagagli</div>
      <p>
        Per avere una descrizione completa delle condizioni di imbarco
        dei tuoi bagagli relativamente a franchigie, peso, dimensioni,
        accedi alla tua prenotazione sul sito della compagnia aerea
        seguendo le istruzioni indicate qui sopra.
      </p>
      <hr />
      <div class="h3 ml-0 mb-1">Gestione della prenotazione</div>
      <p>
        Tutte le possibili opzioni di gestione della tua prenotazione
        sono disponibili facendo accesso al sito della compagnia
        seguendo le istruzioni riportate qui sopra.
      </p>
      <hr />
      <div class="h3 ml-0 mb-1">Acquisito di servizi aggiuntivi</div>
      <p>
        Sul sito della compagnia, se non già inclusi nella tariffa che
        hai prenotato, potrai aggiungere alla tua prenotazione una ampia
        lista di servizi come posti selezionati, imbarco prioritario,
        bagagli aggiuntivi, bagagli speciali, ecc.
      </p>
      <hr />
      <div class="h3 ml-0 mb-1">Covid</div>
      <p>
        Trovi le informazioni adeguate relativamente alle normative di
        sicurezza Covid sul sito
        <a href="https://www.viaggiaresicuri.it/home" target="_blank">Viaggiare sicuri</a>
        del Ministero degli esteri e sul sito della compagnia aerea.
      </p>
      <hr />
      <div class="h3 ml-0 mb-1">
        Richieste di assistenza ed esigenze speciali
      </div>
      <p>
        Se hai necessità di una assistenza speciale per motivi di
        disabilità o salute ti invitiamo a contattare la compagnia
        aerea. Lo stesso consiglio vale per esigenze alimentari
        speciali.
      </p>
    </content-section>
  </div>
</template>

<script>
import ContentSection from "@liveflight/components/blocks/wrappers/content-section.vue";

export default {
  name: "booking-instructions",

  components: {
    "content-section": ContentSection,
  },

  props: {
    // codice/numero di prenotazione presso la compagnia (carrierReference)
    carrier_reference: {
      type: String,
      default: "",
    },
    // nominativo del contatto con cui accedere sul sito della compagnia
    contact_name_surname: {
      type: String,
      default: "",
    },
    // email associata al PNR
    email_pnr: {
      type: String,
      default: "",
    },
  },
};
</script>